export type Result<T, E = undefined> = { ok: true; value: T } | { ok: false; error: E | undefined };

export const Ok = <T>(data: T): Result<T, never> => ({ ok: true, value: data });
export const Err = <E>(error?: E): Result<never, E> => ({ ok: false, error });
